<template>
  <div class="masters-at-work">
    <div class="masters-at-work__header">
      <div class="masters-at-work__header__title">
        {{ mawData.title }}
      </div>
      <div class="masters-at-work__header__subtitle">
        {{ mawData.subtitle }}
      </div>
    </div>
    <div class="masters-at-work__body">
      <SfCarousel class="maw-slider" :settings="mawSliderSettings">
        <template #prev>
          <div />
        </template>
        <SfCarouselItem
          v-for="(section, index) in sections"
          :key="`maw-slider-${index}`"
          class="maw-slider__section"
        >
          <CustomCta
            class="maw-slider__button"
            @click="handleDisplay(section)"
            :theme="`${section === sectionClicked ? 'dark' : 'light'}`"
          >
            <span class="maw-slider__button__label">
              {{ $t(section.replace('-', ' ')) }}
            </span>
          </CustomCta>
        </SfCarouselItem>
        <template #next>
          <div />
        </template>
      </SfCarousel>
      <div class="maw-slide">
        <WideBanner
          v-if="
            mawData[sectionClicked] &&
            mawData[sectionClicked].banner &&
            mawData[sectionClicked].banner.active
          "
          :data="mawData[sectionClicked].banner.data"
          :name="sectionClicked"
          :key="sectionClicked"
          :squareVideo="!isDesktop"
        />
        <TwoBlocksDescription
          v-if="
            mawData[sectionClicked] &&
            mawData[sectionClicked].tit &&
            mawData[sectionClicked].banner.active
          "
          :data="mawData[sectionClicked].tit.data"
        />
        <EditorialProductCarousel
          v-if="mawData[sectionClicked] && mawData[sectionClicked].uid"
          :categoryUid="mawCategoryUid"
          :key="`category-${mawData[sectionClicked].uid}`"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { SfCarousel } from '@storefront-ui/vue';
import { CustomCta } from '~/components/General';
import TwoBlocksDescription from '../Commons/TwoBlocksDescription.vue';
import WideBanner from '../Commons/WideBanner.vue';
import EditorialProductCarousel from '../Commons/EditorialProductCarousel.vue';
import { useWindow } from '~/composables';

export default defineComponent({
  name: 'MastersAtWork',
  components: {
    SfCarousel,
    CustomCta,
    TwoBlocksDescription,
    WideBanner,
    EditorialProductCarousel,
  },
  props: {
    mawData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { isDesktop } = useWindow();
    const sections = ref([
      'classic-workmanship',
      'blowing',
      'plate',
      'caged-glass',
      'mirrors',
    ]);
    const sectionClicked = ref(sections.value[0]);
    const mawCategoryUid = ref(props.mawData[sectionClicked.value].uid);
    const handleDisplay = (element) => {
      sectionClicked.value = element;
      mawCategoryUid.value = props.mawData[sectionClicked.value]?.uid;
    };
    const mawSliderSettings = {
      type: 'carousel',
      perView: 7,
      startAt: 0,
      gap: 20,
      peek: 0,
      breakpoints: {
        400: {
          perView: 1,
          focusAt: '0',
          peek: 70,
          gap: 30,
        },
        569: {
          perView: 1.5,
          focusAt: '0',
          peek: 70,
          gap: 30,
        },
        767: {
          perView: 2,
          focusAt: '0',
          peek: 70,
          gap: 30,
        },
        1023: {
          perView: 3,
          peek: 70,
          gap: 30,
        },
        1279: {
          perView: 4,
          peek: 40,
          gap: 20,
        },
      },
    };

    return {
      isDesktop,
      sections,
      mawSliderSettings,
      handleDisplay,
      sectionClicked,
      mawCategoryUid,
    };
  },
});
</script>

<style lang="scss" scoped>
.masters-at-work {
  padding: 2.5rem 1.25rem;
  &__header {
    text-align: center;
    @include for-desktop {
      @include desktop-boxed;
      margin: 0 auto;
    }
    &__title {
      @include mobile-h4;
      padding-bottom: 1.25rem;
      @include for-desktop {
        @include desktop-h4;
      }
    }
    &__subtitle {
      @include paragraph-l;
      padding-bottom: 1.875rem;
      @include for-desktop {
        padding-bottom: 2.5rem;
      }
    }
  }
  &__body {
    .maw-slider {
      &__section {
        @include for-desktop {
          .custom-button {
            min-width: 0;
          }
        }
      }
      @include for-mobile {
        &__button {
          &__label {
            font-size: 0.8125rem;
          }
        }
      }
    }
    .maw-slide {
      padding-top: 1.875rem;
      @include for-desktop {
        padding-top: 3.75rem;
      }

      .tbd-container {
        @include for-desktop {
          padding: 5rem 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.maw-slider {
  .sf-carousel {
    &__wrapper {
      max-width: 100%;
    }
  }
}
</style>
